import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { defineStore } from 'pinia';

import { useApi } from '@/composables/useApi';

export default defineStore('agent/staff', () => {
	const VueRoute = useRoute();

	const staff = ref(null);
	const isLoading = ref(false);

	async function get(agentId = VueRoute.params.agentID) {
		isLoading.value = true;

		const result = await useApi(`api/agents/${agentId}/staff/`, {
			message: 'There was an issue retrieving the staff account. Please try again later.',
		}).json();

		isLoading.value = false;
		staff.value = result.data?.value;
		return result.data?.value;
	}

	async function ensureStaff() {
		if (!staff.value) {
			await get();
		}
	}

	async function updatePermissions(newPermissions) {
		isLoading.value = true;

		try {
			await useApi(`api/agents/${VueRoute.params.agentID}/staff/permissions/`, {
				headers: { 'content-type': 'application/json' },
				message:
					'There was an issue with updating your staff settings. Please try again later.',
			}).put(JSON.stringify(newPermissions));
			await get();
		} catch (error) {
			console.error(error);
			throw error;
		} finally {
			isLoading.value = false;
		}
	}

	function findFromAlias(alias) {
		if (!staff.value) {
			return null;
		}

		return staff.value.find(s => s.alias === alias);
	}

	return {
		staff,
		isLoading,

		get,
		ensureStaff,
		updatePermissions,
		findFromAlias,
	};
});
